import loyaltyProgramMdl from "./loyaltyProgram.mdl";
import redemptionCenterMdl from "./redemptionCenter.mdl";

export default [...loyaltyProgramMdl, ...redemptionCenterMdl];
